import { useCallback, useEffect, useRef } from 'react'

type DialogType = 'popover' | 'modal'

export const useDialogVisibility = (
  isVisible = true,
  type: DialogType = 'popover'
) => {
  const dialogRef = useRef<HTMLDialogElement>(null)

  const openDialog = useCallback(() => {
    if (dialogRef.current?.open) {
      return
    }

    if (type === 'popover') {
      dialogRef.current?.show()
      return
    }

    dialogRef.current?.showModal()
  }, [type])

  const closeDialog = () => {
    if (!dialogRef.current?.open) {
      return
    }

    dialogRef.current?.close()
  }

  const handleDialogVisibility = useCallback(() => {
    if (isVisible) {
      openDialog()

      return
    }

    closeDialog()
  }, [isVisible, openDialog])

  useEffect(() => {
    handleDialogVisibility()
  }, [handleDialogVisibility])

  return {
    dialogRef
  }
}
